import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { modal } from '@/src/utils/Modal';
import { get } from 'lodash';
import React from 'react';
import { useHistory, useParams } from 'react-router';
//import Trigger from 'src/constrains/Query1/Filter/DropDown/Trigger';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import _Query, { EnumQueryType } from 'src/constrains/Query1';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { useI18n } from 'src/hooks/useRouterChange';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { ETagType } from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Settings';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { deleteTags, getTags } from 'src/request/customer/tag';
import { NEW, defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EDeletionType, ESort } from 'src/types/common';
import { EnumTablePosition } from 'src/types/common/common';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import css from './css.module.less';

const permissions = () => {
  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerTagDetailsPage,
        operation: EnumOperation.delete_tag,
      }),
    ],
  });

  const canView = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerTagDetailsPage,
        operation: EnumOperation.view_customer_tag_details_page,
      }),
    ],
  });

  const canAdd = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerTagGeneral,
        operation: EnumOperation.add_tag,
      }),
    ],
  });
  return {
    canDelete,
    canAdd,
    canView,
  };
};

const convertQuery = (filter) => {
  const re: any = {};
  if (filter.tagType) {
    if (filter.tagType.length > 0) {
      re.tagType = filter.tagType.map((i) => {
        const { value } = i;
        return { value };
      });
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};

const filterConfig = ({ getI18n }) => [
  {
    type: EnumFilterType.SingleSelection,

    dropdownProps: { name: getI18n('customerTag.customerTag_List.tagType') },
    keyWord: 'tagType',
    options: [
      //定义排序所需的数据
      {
        label: getI18n('customerTag.customerTag_List.manual'),
        value: ETagType.Manual,
      },
      {
        label: getI18n('customerTag.customerTag_List.auto'),
        value: ETagType.Auto,
      },
    ],
  },
];
// const orderDict: any = {
//   descend: 'desc',
//   ascend: 'asc',
// };

const _sort = {
  title: '',
  tagType: '',
};

const TagList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { canDelete, canAdd, canView } = permissions();
  const { customerDatabaseUuid }: any = useParams();
  const h = useHistory();
  //const [filter, setFilter] = React.useState<any>({});

  //const [search, setSearch] = React.useState('');
  const [sort, setSort] = React.useState({ ..._sort });
  const { clearSearchState, queryProps, search } = useQueries(
    filterConfig({ getI18n }),
    [],
    convertQuery,
  );
  /* 分页 */
  const [current, setCurrent] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };
  const col = (onEdit, onDelete, sort) => {
    return [
      {
        minWidth: 400,
        key: 'title',
        default: true,
        sorter: true,
        sortOrder: sort.title,
        title: getI18n('customerTag.customerTag_List.customerTagTitle'),
        // title: name,
        childGenerate: (_, record) => {
          const title = get(record, 'title');

          return (
            <NoWrapContainer>
              <Tooltip title={title}>{title}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        width: 200,
        key: 'tagType',
        default: true,
        title: getI18n('customerTag.customerTag_List.tagType'),
        childGenerate: (_, record) => {
          const tagType = get(record, 'tagType');
          const name =
            {
              [ETagType.Auto]: getI18n('customerTag.customerTag_List.autoTag'),
              [ETagType.Manual]: getI18n(
                'customerTag.customerTag_List.manualTag',
              ),
            }[tagType] || '-';
          return (
            <NoWrapContainer>
              <Tooltip title={name}>{name}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        width: 192,
        key: 'appliedTo',
        default: true,
        title: getI18n('customerTag.customerTag_List.numberofCustomers'),
        sorter: true,
        sortOrder: sort.appliedTo,
        childGenerate: (_, record) => {
          const appliedTo = get(record, 'appliedTo');
          const uuid = get(record, 'uuid');

          return (
            <div
              className={css.numOfCustomer}
              onClick={() => {
                h.push(
                  `/customerDatabase/customerList/${customerDatabaseUuid}?tagUuid=${uuid}`,
                );
              }}>
              {appliedTo}
            </div>
          );
        },
      },
      {
        titleGenerate: () => getI18n('customerTag.customerTag_List.actions'),
        position: EnumTablePosition.mid,
        key: 'Actions',
        width: 190,
        default: true,
        childGenerate: (url, record, index) => {
          return (
            <Actions
              disableDelete={!canDelete}
              disableEdit={!canView}
              onDelete={() => {
                if (onDelete && canDelete) onDelete(record);
              }}
              onEdit={() => {
                if (onEdit && canView) onEdit(record);
              }}
              isReverse
            />
          );
        },
      },
    ];
  };

  // const { customerDatabaseUuid }: any = useParams();
  const [
    loaded, // setLoaded
  ] = React.useState(true);
  //
  const [data, setData] = React.useState([]);
  const _filter = React.useMemo(() => {
    const { tagType } = search || {};
    if (tagType && tagType[0]) {
      const { value } = tagType[0] || {};
      return { tagType: value };
    }
    return {};
  }, [search]);
  const __sort = React.useMemo(() => {
    return Object.keys(sort).reduce((pre, now) => {
      const order = sort[now];

      if (order) {
        return {
          field: now,
          ascent: sort[now] === ESort.asc,
        };
      }
      return pre;
    }, null);
  }, [sort]);
  const filtersGenerator = React.useMemo(() => {
    const filters = {
      ...(_filter || {}),
      searchText: (search || {}).searchText ? (search || {}).searchText : [],
      sortBy: __sort,
    };
    return filters;
  }, [search, __sort]);
  const constants = {
    ...(filtersGenerator || {}),
    customerDatabaseUuid: customerDatabaseUuid,
    // firstRow: current * pageSize,
    // countPerPage: pageSize,
  };

  const getData = () => {
    getTags(current * pageSize, pageSize, constants).then((res: any) => {
      const { results, totalCount } = res;
      setTotal(totalCount);
      setData(results || []);
    });
    //return listSearch(customerDatabaseUuid, constants);
  };

  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(data);

  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  const handleOnTableChange = (pagination: any, filters: any, sorter: any) => {
    const { columnKey, order } = sorter;
    const _defaultSort: any = { ..._sort };
    _defaultSort[columnKey] = order;
    setSort(_defaultSort);
  };

  React.useEffect(() => {
    getTags(current * pageSize, pageSize, constants).then((res: any) => {
      const { results, totalCount } = res;
      setTotal(totalCount);
      setData(results || []);
      setTotalCount(totalCount);
    });
  }, []);

  const handleOnSingleDelete = (tag) => {
    const { uuid } = tag;
    const deletionType = EDeletionType.Selected;
    const payload = { deletionType, customerTagUuids: [uuid] };
    modal.error({
      title: getI18n('customerTag.customerTag_List.deleteCustomerTag'),
      content: getI18n('customerTag.customerTag_List.remind_cannotberecovered'),
      onOkText: getI18n('general.delete'),
      onOk: () => {
        handleOnDelete(payload);
      },
      onCancel: () => {
        return;
      },
    });
  };

  const handleOnEdit = (tag) => {
    const { uuid } = tag;
    //customerDatabaseUuid
    h.push(`/customerDatabase/tagEdit/${customerDatabaseUuid}/${uuid}`);
  };

  useAfterDidMountEffect(() => {
    getData();
  }, [current]);

  useAfterDidMountEffect(() => {
    if (!current) {
      getData();
    } else {
      setCurrent(0);
    }
  }, [pageSize, filtersGenerator]);

  const handleOnDelete = (body) => {
    deleteTags(body).then((res: any) => {
      if (res) {
        msg.success(getI18n('customerTag.customerTag_List.deletesuccess'));
        clearSearchState();
        clearTableState();
        if (current === 0) {
          getData();
        } else {
          setCurrent(0);
        }
      }
    });
  };

  const buttonMenu = [
    //Bulk Edit
    {
      key: 1,
      value: getI18n('general.delete'),
      function: () => {
        const deletionType = selectedAll
          ? EDeletionType.All
          : EDeletionType.Selected;
        const payload = { deletionType, customerTagUuids: selectedRowKeys };
        modal.error({
          title: getI18n('customerTag.customerTag_List.deleteCustomerTag'),
          content: getI18n(
            'customerTag.customerTag_List.remind_cannotberecovered',
          ),
          onOkText: getI18n('general.delete'),
          onOk: () => {
            handleOnDelete(payload);
          },
          onCancel: () => {
            return;
          },
        });
      },
    },
  ];
  const pageLayoutProps = {
    title: getI18n('customerTag.customerTag_List.customerTagList'),
    addText: getI18n('customerTag.customerTag_List.addTag'),
    addFun: canAdd
      ? () => {
          h.push(
            `/customerDatabase/tagEdit/${customerDatabaseUuid}/${NEW}?count=${
              totalCount + 1
            }`,
          );
        }
      : null,
    // exportFun,
    // importFun,

    activeKey: 'All',
    tabsConfig: [
      //定义tabs列表
      { name: getI18n('general.all'), key: 'All' },
    ],
  };
  const handleOnSearchChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ search: e, type: EnumQueryType.search });
    }
  };

  const handleOnFilterChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ filter: e, type: EnumQueryType.filter });
    }
  };

  const handleOnSortChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ sort: e, type: EnumQueryType.sort });
    }
  };

  const handleOnSearchClose = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ item: e, type: EnumQueryType.closeTag });
    }
  };

  return (
    <ListPageLayout {...pageLayoutProps}>
      <div className={css.topContainer}>
        <_Query
          onSearchChange={handleOnSearchChange}
          onFilterChange={handleOnFilterChange}
          onSortChange={handleOnSortChange}
          onTagClose={handleOnSearchClose}
          filters={queryProps.filters || []}
          sortList={queryProps.sortList || []}
          data={queryProps.searchConditions || []}
        />
        {/* <Search
          enterButton='Search'
          onSearch={setSearch}
          allowClear
          placeholder='Search customer'
          formClassName={css.search}
        />
        <FilterGroup
          filters={filterConfig}
          data={filter}
          onChange={setFilter}
        /> */}
      </div>
      {true && (
        <GlobalTable
          id={'CustomerDataBaseTagListTable'}
          showSorterTooltip={false}
          onChange={handleOnTableChange}
          hideQuery
          dataSource={data}
          columns={col(handleOnEdit, handleOnSingleDelete, sort)}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          buttonMenu={buttonMenu}
          rowKey='uuid'
          pagination={paginationProps}
          current={current}
          setCurrent={setCurrent}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
          rowSelection={rowSelection}
          selectedRowKeys={selectedRowKeys}
          // mappedSelectedKeys={mappedSelectedKeys}
          hidePagination={total == 0}
          loading={!loaded}
          className={css.table123}
          // handleTableSettingChange={handleTableSettingChange}
          // tableSettings={tableSettings}
        />
      )}
    </ListPageLayout>
  );
};
export default TagList;
